export interface OrderLeg {
  action: 'BTO' | 'STO' | 'BTC' | 'STC';
  quantity: number;
  symbol: string;
  expiration: string; // YYYY-MM-DD or M/D/YYYY
  strike: number;
  optionType: 'put' | 'call';
}

export interface OrderTicket {
  symbol: string;
  strategy: string; // e.g., "Vertical Call Spread", "Iron Condor"
  legs: OrderLeg[];
  netCredit?: number;
  netDebit?: number;
}

const actionLabels: Record<OrderLeg['action'], string> = {
  BTO: 'Buy to Open',
  STO: 'Sell to Open',
  BTC: 'Buy to Close',
  STC: 'Sell to Close',
};

function formatExpiration(exp: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(exp)) {
    const [y, m, d] = exp.split('-');
    return `${m}/${d}/${y}`;
  }
  return exp;
}

export function formatOrderTicket(order: OrderTicket): string {
  const lines: string[] = [];
  const firstLeg = order.legs[0];
  lines.push(`${order.symbol} ${formatExpiration(firstLeg.expiration)} — ${order.strategy}`);
  for (const leg of order.legs) {
    const typeStr = leg.optionType === 'put' ? 'Put' : 'Call';
    lines.push(`  ${actionLabels[leg.action]}  ${leg.quantity}  ${leg.strike} ${typeStr}`);
  }
  if (order.netCredit != null) {
    lines.push(`  Net credit limit: $${order.netCredit.toFixed(2)}`);
  } else if (order.netDebit != null) {
    lines.push(`  Net debit limit: $${order.netDebit.toFixed(2)}`);
  }
  return lines.join('\n');
}
